import React from "react";
import { Link } from "react-router-dom";
import companyLogo from "../../../../../Images/CompanyLogo.avif";

export default function CompanyCard({ company }) {
  return (
    <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-3">
      <div className="company card">
        <Link to={`/Companies/Company/${company?.id}`}>
          <div className="company-img  card-header">
            <img src={companyLogo} alt="" />
            <h3 className="mt-2">{company?.name}</h3>
          </div>
        </Link>
        <div className="company-info card-body">
          <div className="row">
            <p className="col-6">{company?.city}</p>
            <p className="col-6" dir="ltr">
              <a target="_blank" rel="noreferrer" href="https://www.google.com/maps/place/%D9%85%D9%88%D9%84+%D8%A3%D8%A8%D9%88+%D8%A7%D9%84%D9%88%D9%81%D8%A7%E2%80%AD/@30.2960614,31.7372868,16z/data=!4m6!3m5!1s0x1457fdc1e9b5669f:0x6930075570e52f58!8m2!3d30.2930271!4d31.7379783!16s%2Fg%2F11c1t4_zpf?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D">
                <i class="fa-solid fa-location-dot fa-xl"></i>
              </a>
            </p>
          </div>
          <p className="">
            <a href="tel:+966111234567">{company?.phone}</a>
          </p>
          <p className="">
            <a href={`mailto:${company?.email}`}>{company?.email}</a>
          </p>

          <span className="position-absolute top-0 end-0 py-1 px-2 rounded-5 bg-100-text primary-100-bg ">
            <i class="fa-solid fa-check"></i>
          </span>
        </div>
      </div>
    </div>
  );
}
